<script setup lang="ts">
import { BoxComponent, ButtonComponent, DateRangeSelector, FlexComponent, PageWrapperComponent } from '@metapic-apps/shared'
import { ElIcon } from 'element-plus'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import { useFileDownload } from '@/api/file-download.api'
import { buildOrdersExportUrl } from '@/api/orders.api'
import ExportIcon from '@/assets/icons/export.svg?component'
import { OrdersList } from '@/components/orders/OrdersList'
import { OrdersMetrics } from '@/components/orders/OrdersMetrics'
import { OrderTracking } from '@/components/orders/OrderTracking'
import { useAdvertiserStore } from '@/stores/advertiser.stores'
import { useGlobalFilterStore } from '@/stores/global-filter.stores'
const store = useStore()
const advertiserStore = useAdvertiserStore()
const filterStore = useGlobalFilterStore()
const isDirectStore = computed<boolean>(() => store.getters['shop/isDirectStore'])
const { downloadFile, isLoading: isExporting } = useFileDownload()
const exportOrders = async () => {
  const shopId = advertiserStore.advertiser?.id
  if (!shopId) {
    return
  }
  await downloadFile(
    buildOrdersExportUrl(shopId, {
      page: 1,
      dateFrom: filterStore.dateRange?.startDate,
      dateTo: filterStore.dateRange?.endDate,
    }),
    'orders.xlsx',
  )
}
onMounted(() => {
  if (store.getters['onboarding/currentOnboardingStep'] === 1) {
    void store.dispatch('onboarding/setCurrentCard', 'order-sales-collection-section')
    void store.dispatch('onboarding/setOnboardingActivity', true)
  }
})
</script>
<template>
  <div class="orders">
    <PageWrapperComponent>
      <FlexComponent direction="column" :gap="24">
        <OrderTracking v-if="isDirectStore" />
        <FlexComponent justify="flex-end" align="center" :gap="16">
          <DateRangeSelector :date-range="filterStore.dateRange" @update:date-range="filterStore.setDateRange" />
          <ButtonComponent variant="accent" :is-loading="isExporting" class="orders__export" @click="exportOrders">
            <template #iconLeft>
              <ElIcon :size="16">
                <ExportIcon />
              </ElIcon>
            </template>
            Export
          </ButtonComponent>
        </FlexComponent>
        <OrdersMetrics />
        <BoxComponent>
          <OrdersList />
        </BoxComponent>
      </FlexComponent>
    </PageWrapperComponent>
  </div>
</template>
<style scoped lang="scss">
.orders__export.orders__export {
  :deep(svg) {
    fill: currentColor;
  }
}
</style>
